import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=2c45c2e1&scoped=true&"
import script from "./ServiceSection.vue?vue&type=script&lang=js&"
export * from "./ServiceSection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=2c45c2e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45c2e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
